import request from '@/utils/request'

// 查询6项数据
export function getVisitsStatistics(data) {
  return request({
    url: '/health-followup/followup/conversion/statistics/overview',
    method: 'post',
    data
  })
}

export function isPlanOrVisit(data) {
  return request({
    url: '/health-followup/followup/plan/card/checkNewFollowUp',
    method: 'post',
    data
  })
}

// 随访列表
export function getVisits(data) {
  return request({
    url: '/health-followup/followup/plan/list/da-new',
    method: 'post',
    data
  })
}
// 用药计划列表
export function getVisitsNew(data) {
  return request({
    url: '/health-followup/followup/plan/card/list/da-new',
    method: 'post',
    data
  })
}
/**
 * @description: 随访列表详情
 * @param {Number} followupPlanId
 */
export function visitsDetail(data) {
  return request({
    url: '/health-followup/followup/plan/detail/da-new',
    method: 'get',
    params: data
  })
}
// 用药计划列表详情
export function visitsDetailNew(data) {
  return request({
    url: '/health-followup/followup/plan/card/detail/da-new',
    method: 'get',
    params: data
  })
}
// 取消随访计划
export function cancelVisitPlan(followupPlanId) {
  return request({
    headers: {
      _p: 3
    },
    url: '/health-followup/followup/plan/cancel',
    method: 'post',
    params: {
      followupPlanId
    }
  })
}
// 随访可关联处方列表
export function getPrescriList(params) {
  return request({
    headers: {
      _p: 3
    },
    url: '/health-followup/followup/plan/srelevancyPrescription/list',
    method: 'get',
    params: params
  })
}
// 修改随访关联处方
export function updataVisitPrescri(params) {
  return request({
    headers: {
      _p: 3
    },
    url: '/health-followup/followup/plan/srelevancyPrescription/update',
    method: 'post',
    params: params
  })
}
//更新随访流程
export function updataPlanFlow(params) {
  return request({
    headers: {
      _p: 3
    },
    url: '/health-followup/followup/plan-flow/update',
    method: 'post',
    data: params
  })
}
// 取消指定随访流程
export function cancelPlanFlow(params) {
  return request({
    headers: {
      _p: 3
    },
    url: '/health-followup/followup/plan-flow/cancel',
    method: 'post',
    params: params
  })
}
//医助创建随访计划流程
export function createPlanFlow(params) {
  return request({
    headers: {
      _p: 3
    },
    url: '/health-followup/followup/plan-flow/create',
    method: 'post',
    data: params
  })
}
// 查询随访具体某个流程的信息
export function getFollowUpPlanFlowDTOById(data) {
  return request({
    url: '/health-followup/followup/plan-flow/flow/selectFollowUpPlanFlowDTOById',
    method: 'get',
    params: data
  })
}
